import { IconProps } from '@mui/material'
import React from 'react'

const Collapse: React.FC<IconProps> = () => {
  return (
    <svg viewBox="0 0 16 16" fill="none">
      <path
        d="M2.22003 3.01591C1.9996 2.79548 1.9996 2.43889 2.22003 2.21845C2.44047 1.99802 2.79706 1.99802 3.0175 2.21845L5.78039 4.98135V3.44509C5.78039 3.13384 6.03249 2.88114 6.34435 2.88114C6.6562 2.88114 6.9083 3.13384 6.9083 3.44509V6.34276C6.9083 6.6545 6.65365 6.90672 6.34435 6.90672H3.44667C3.13481 6.90672 2.88272 6.65401 2.88272 6.34276C2.88272 6.03152 3.13481 5.77881 3.44667 5.77881H4.98293L2.22003 3.01591Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M9.09182 12.5538V9.65614C9.09182 9.34674 9.34455 9.09219 9.65577 9.09219H12.5534C12.8652 9.09219 13.1174 9.34438 13.1174 9.65614C13.1174 9.9679 12.8652 10.2201 12.5534 10.2201H11.0172L13.7801 12.983C14.0005 13.2034 14.0005 13.56 13.7801 13.7805C13.5596 14.0009 13.2031 14.0009 12.9826 13.7805L10.2197 11.0176V12.5538C10.2197 12.8656 9.96753 13.1178 9.65577 13.1178C9.34401 13.1178 9.09182 12.8656 9.09182 12.5538Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M9.09182 6.34276V3.44509C9.09182 3.13384 9.34391 2.88114 9.65577 2.88114C9.96763 2.88114 10.2197 3.13384 10.2197 3.44509V4.98135L12.9826 2.21845C13.2031 1.99802 13.5596 1.99802 13.7801 2.21845C14.0005 2.43889 14.0005 2.79548 13.7801 3.01591L11.0172 5.77881H12.5534C12.8653 5.77881 13.1174 6.03152 13.1174 6.34276C13.1174 6.65401 12.8653 6.90672 12.5534 6.90672H9.65577C9.34932 6.90672 9.09182 6.65652 9.09182 6.34276Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
      <path
        d="M2.22003 13.7805C1.9996 13.56 1.9996 13.2034 2.22003 12.983L4.98293 10.2201H3.44667C3.13491 10.2201 2.88272 9.9679 2.88272 9.65614C2.88272 9.34438 3.13491 9.09219 3.44667 9.09219H6.34435C6.65669 9.09219 6.9083 9.34745 6.9083 9.65614V12.5538C6.9083 12.8656 6.65611 13.1178 6.34435 13.1178C6.03259 13.1178 5.78039 12.8656 5.78039 12.5538V11.0176L3.0175 13.7805C2.79706 14.0009 2.44047 14.0009 2.22003 13.7805Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.3"
      />
    </svg>
  )
}

export default Collapse
